// extracted by mini-css-extract-plugin
export default {"dropzone":"ProfileImagePicker-module--dropzone--TTBN0"};